"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTransactionFee = void 0;
const tslib_1 = require("tslib");
const jsbi_1 = tslib_1.__importDefault(require("jsbi"));
const validators_1 = require("./validators");
exports.calculateTransactionFee = (transactionSize, feeRate) => {
    validators_1.assertToBeHexStringOrBigint(transactionSize);
    validators_1.assertToBeHexStringOrBigint(feeRate);
    const ratio = jsbi_1.default.BigInt(1000);
    const base = jsbi_1.default.multiply(jsbi_1.default.BigInt(`${transactionSize}`), jsbi_1.default.BigInt(`${feeRate}`));
    const fee = jsbi_1.default.divide(base, ratio);
    if (jsbi_1.default.lessThan(jsbi_1.default.multiply(fee, ratio), base)) {
        return `0x${jsbi_1.default.add(fee, jsbi_1.default.BigInt(1)).toString(16)}`;
    }
    return `0x${fee.toString(16)}`;
};
exports.default = exports.calculateTransactionFee;
//# sourceMappingURL=calculateTransactionFee.js.map